module.exports = __webpack_public_path__ + "img/hint.a66e3383.png";